// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__oxcrZ","label":"SetPasswdForm_label__kjl3R"};